<template>
  <vs-popup
    fullscreen
    :title="title_popup"
    :active.sync="config.isActive"
    id="add-order-item"
    @close="closePopup"
  >
    <div class="relative">
      <div class="overflow-hidden" style="height:calc(100vh - 155px);">
        <div class="h-full overflow-auto">
          <div class="md:flex mt-5 pl-6">
            <div class="w-full md:w-1/2 pr-6">
              <label class="label">Product Name</label>
              <!-- <vs-input
                placeholder="Product Name"
                name="item_name"
                v-model="item_name"
                class="w-full mb-5"
                required
              /> -->
              <div style="height: 56px;">
                <vs-input v-validate="'required'" name="item_name" v-model="item_name" placeholder="Product name" class="w-full" :class="!errors.has('item_name')" :danger="errors.has('item_name')"
                  danger-text="The name field is required"/>
              </div>

              <label class="label">Category</label>
              <v-select @input="selectId($event)"
              label="name"
              :options="optionsCate.items"
              v-model="cate"
              :value="cate"
               class="w-full mb-4"
              :clearable="false"
              :searchable="false">
              </v-select>

              <label class="label">Type</label>
              <v-select
                v-model="selectedType"
                :options="optionsType"
                :dir="$vs.rtl ? 'rtl' : 'ltr'"
                class="w-full mb-5"
                :clearable="false"
                :searchable="false"
                :disabled="true"
              />

              <label class="label">
                Prepare duration
                <span class="text-sm">- minute</span>
              </label>
              <vs-input
                placeholder="Input prepare duration"
                v-model="item_duration"
                class="w-full mb-5"
                v-on:keypress="isNumber($event)"
              />

              <label class="label">Description</label>
              <vs-textarea
                height="120px"
                placeholder="Input description"
                name="item_description"
                v-model="item_description"
                class="w-full mb-5 disable-resize"
              />
            </div>
            <div class="w-full md:w-1/2 pr-6 md:pl-6 pl-0">
              <!-- <vs-row>
          <vs-col vs-w="6" class="pr-3">
            <label class="label">
              Barcode
              <span class="text text-xs">(ISBN, UPC, etc.)</span>
            </label>
            <vs-input placeholder="Barcode" v-model="name" class="w-full" />
          </vs-col>
          <vs-col vs-w="6" class="pl-3">
            <label class="label">
              SKU
              <span class="text text-sm">Stock Keeping Unit</span>
            </label>
            <vs-input placeholder="SKU" v-model="name" class="w-full" />
          </vs-col>
              </vs-row>-->
              <div class="md:flex">
                <div class="w-full">
                  <label class="label">Nutritional info</label>
                  <vs-textarea
                    height="195px"
                    placeholder="Input description (disabled)"
                    disabled
                    class="w-full mb-4"
                  />
                </div>
                <div class="md:pl-6">
                <image-uploader
                  v-if="config.isActive"
                  :item="config.item_info"
                  @uploaded-done="handleUploaded"
                  :isVariant="false"
                  style="margin-top: 18px"
                ></image-uploader>
                </div>
              </div>

              <!-- <label class="label">
                Prepare duration
                <span class="text-sm">- minute</span>
              </label>
              <vs-input
                placeholder="Input prepare duration"
                v-model="item_duration"
                class="w-full mb-5"
                v-on:keypress="isNumber($event)"
              /> -->

              <label class="label d-inline-block mt-1">Note</label>
              <vs-textarea
                height="200px"
                placeholder="Input note"
                v-model="item_note"
                class="w-full mb-5"
              />
            </div>
          </div>

          <div class="mx-6 mb-base" :key="item_key">
            <label class="label">Variation</label>
            <div class="overflow-auto">
            <vs-row class="border-custom border-r-0 border-b-0" style="min-width: 700px;">
              <vs-col vs-w="3" class="border-right-custom text-center p-2 bg-custom">Name</vs-col>
              <vs-col vs-w="4" class="border-right-custom text-center p-2 bg-custom">Description</vs-col>
              <vs-col vs-w="3" class="border-right-custom text-center p-2 bg-custom">Price - $</vs-col>
              <vs-col vs-w="2" class="border-right-custom text-center p-2 bg-custom">Remove</vs-col>
            </vs-row>
            <vs-row
              class="border-custom border-r-0 variant-table border-t-0"
              v-for="(variant, index) in variant_list"
              :key="'variant'+index"
               style="min-width: 700px;"
            >
              <vs-col vs-w="3" class="border-right-custom text-center p-2">
                <vs-input v-model="variant.name" class="w-full h-full" />
              </vs-col>
              <vs-col vs-w="4" class="border-right-custom text-center p-2">
                <vs-input v-model="variant.description" class="w-full h-full" />
              </vs-col>
              <vs-col vs-w="3" class="border-right-custom text-center p-2">
                <vs-input
                  v-model="variant.price"
                  class="w-full h-full"
                  v-on:keypress="isPriceNumber($event, variant.price)"
                />
              </vs-col>
              <vs-col
                vs-w="2"
                class="border-right-custom text-center p-2 flex align-center justify-center"
              >
                <feather-icon
                  icon="TrashIcon"
                  svgClasses="h-5 w-5 stroke-current text-primary"
                  @click="removeVariation(variant)"
                  v-if="variant_list.length>1"
                />
              </vs-col>
            </vs-row>
            </div>
            <vs-button class="my-4" @click="addVariation">Add variation</vs-button>

            <label class="label">Modifier</label>
            <div class="overflow-auto">
              <vs-row class="border-custom border-r-0 border-b-0" style="min-width: 700px">
                <vs-col
                  vs-w="1"
                  class="border-right-custom p-2 bg-custom flex align-center justify-center"
                >Visible</vs-col>
                <vs-col vs-w="10" class="border-right-custom p-2 bg-custom">
                  <span class="d-inline-block" style="padding: 0.5rem 0.7rem;">Name</span>
                </vs-col>
                <vs-col vs-w="1" class="border-right-custom p-2 bg-custom text-center">
                  <span class="d-inline-block" style="padding: 0.5rem 0.7rem;">Edit</span>
                </vs-col>
              </vs-row>
              <vs-row
                class="border-custom border-r-0 modifier-table border-t-0"
                v-for="(modifier, index) in modifierList"
                :key="'modifier'+index"
                 style="min-width: 700px"
              >
                <vs-col vs-w="1" class="border-right-custom p-2 flex align-center justify-center">
                  <vs-checkbox :value="modifier.is_selected" @click="changeStatusCheckbox(modifier)"></vs-checkbox>
                </vs-col>
                <vs-col vs-w="10" class="border-right-custom p-2">
                  <!-- <vs-input v-model="modifier.title" class="w-full h-full text-left" readonly /> -->
                  {{modifier.title}}:
                  <span class="text-grey-custom" v-if="modifier.details && modifier.details.length > 0">
                    [
                    <span v-for="(detail, i) in modifier.details" :key="i">
                      <span v-if="i != 0">, {{detail.name}}</span>
                      <span v-else>{{detail.name}}</span>
                    </span>
                    ]
                  </span>
                </vs-col>
                <vs-col vs-w="1" class="border-right-custom p-2 flex align-center justify-center">
                  <feather-icon
                    icon="Edit2Icon"
                    svgClasses="h-5 w-5 stroke-current text-primary"
                    @click="editModifier(modifier)"
                  />
                </vs-col>
              </vs-row>
            </div>
            <vs-button class="my-4" @click="addModifier">Add modifier</vs-button>
          </div>
          <!-- <edit-item-modifier :config="editItemModifierCofig" :key="edit_mod_key" @ClosePopup="editItemModifierCofig.isActive = false" @SaveModifier="saveModifier"></edit-item-modifier> -->
          <!-- <vs-row class="mt-5">
      <vs-col vs-w="6" class="pr-6">
        <label class="label">Category</label>
        <v-select
          v-model="selectedCate"
          :options="optionsCate"
          :dir="$vs.rtl ? 'rtl' : 'ltr'"
          class="w-full"
        />
        <br />
        <label class="label">Brand</label>
        <v-select
          v-model="selectedBrand"
          :options="optionsBrand"
          :dir="$vs.rtl ? 'rtl' : 'ltr'"
          class="w-full"
        />
        <br />
      </vs-col>
      <vs-col vs-w="6" class="pl-6">
        <label class="label">Description</label>
        <vs-textarea height="120px" placeholder="Input description" class="w-full" />
      </vs-col>
          </vs-row>-->
        </div>
      </div>
      <div class="w-full" slot="footer">
        <vs-divider class="mt-0"></vs-divider>
        <vs-row class="flex justify-center align-center">
          <vs-button
            v-if="config.item_info === undefined"
            type="border"
            @click="createItem(true)"
          >Create</vs-button>
          <vs-button v-else type="border" @click="createItem(false)">Update</vs-button>
          <vs-button type="border" class="ml-4" color="danger" @click.stop="closePopup">Cancel</vs-button>
        </vs-row>
      </div>
    </div>
    <edit-item-modifier :config="editItemModifierCofig" :key="edit_mod_key + 'A'" @ClosePopup="editItemModifierCofig.isActive = false" @SaveModifier="saveModifier"></edit-item-modifier>
  </vs-popup>
</template>

<script>
import vSelect from "vue-select";
import ImageCropper from "./ImageCropper";
import EditItemModifier from './EditItemModifier.vue';
import { Modifier } from '../../models/order/modifier';

export default {
  name: "add-order-item",
  props: {
    config: {
      type: Object,
      required: true
    },
    title_popup: {
      type: String
    },
    type: {
      type: String,
      required: true
    }
  },
  components: {
    "v-select": vSelect,
    "image-uploader": ImageCropper,
    'edit-item-modifier': EditItemModifier
  },
  data() {
    let defaultList = [
      {
        name: "Normal",
        image: null,
        description: "This is normal size",
        price: 0.00,
        index: 0
      }
    ];
    if (
      this.config.item_info !== undefined &&
      this.config.item_info.item_variants != null
    ) {
      defaultList = JSON.parse(JSON.stringify(this.config.item_info.item_variants));
    }
    for (let i = 0; i < defaultList.length; i++) {
      defaultList[i].index = i;
      defaultList[i].price = parseFloat(defaultList[i].price).toFixed(2);
    }
    // let modifierList = this.$store.getters['modifier/modifierList'];
    let modifierList = this.$store.getters['modifier/modifierList'];
    let new_modifier = [];

    // if(this.type == 'detail' && this.config.item_info && this.config.item_info.modifier) {
      // console.log(this.config.item_info.modifier);
      // for(let i = 0; i < this.config.item_info.modifier.length; i++) {
        //   this.isModifierSelected(this.config.item_info.modifier[i]);
      // }
      modifierList = this.getModifierList();
    // }
    let cate = {};
    let categoryList = this.$store.state.category.categoryList;
    if(this.config && this.config.item_info && categoryList && categoryList.items){
      for(let i = 0; i < categoryList.items.length; i++){
        if(this.config.item_info.category_id == categoryList.items[i].id){
          cate = categoryList.items[i];
        }
      }
    }
    return {
      cate,
      selectedId: 0,
      id: this.config.item_info !== undefined ? this.config.item_info.category_id : null,
      has_err: false,
      // title_popup: "Add new item",
      name:
        this.config.item_info !== undefined ? this.config.item_info.name : "",
      description:
        this.config.item_info !== undefined
          ? this.config.item_info.description
          : "",
      note:
        this.config.item_info !== undefined ? this.config.item_info.note : "",
      duration:
        this.config.item_info !== undefined
          ? this.config.item_info.prepare_duration
          : "",
      optionsType: [
        { id: 1, label: "Food" },
        { id: 3, label: "Drink" },
        { id: 2, label: "Ice cream" }
      ],
      selectedType: { id: 1, label: "Food" },
      item_image: {},

      image_url: "https://www.mbrsg.ae/MBRSG/media/Images/no-image-icon-6.png",
      variant_list: defaultList,
      defaultList,
      popupAddVariant: false,
      modifierList,
      editItemModifierCofig: {
        isActive: false,
        item_info: {},
        type: 'edit',
        modifierList: []
      },
      edit_mod_key: 0,
      item_key: 0,
      new_modifier,
      currentPage: 1,
      itemPerPage: 10,
      // default_modifier: []
    };
  },
  watch: {
    config: {
      immediate: true,
      deep: true,
      handler() {
        this.errors.clear();
        if (this.config.isActive) {
          if(this.modifierList && this.type == 'add') {
            this.name = '';
            // this.id = this.config.item_info !== undefined ? this.config.item_info.category_id : null;
            this.duration = '';
            this.note = '';
            this.description = '';
            this.variant_list = [{
              name: "Normal",
              image: null,
              description: "This is normal size",
              price: 0.00,
              index: 0
            }];
            // this.modifierList = this.getAddStartList(this.new_modifier, this.modifierList);
            this.modifierList = this.getDefaultModifierList();
            this.new_modifier = [];
            for(let i = 0; i < this.modifierList.length; i++) {
              this.modifierList[i].changeStatusFalse();
            }
          }
          this.item_key++;
        } else {
          this.errors.clear();
          if(this.modifierList && this.type == 'add') {
            this.name = '';
            // this.id = this.config.item_info !== undefined ? this.config.item_info.category_id : null;
            this.duration = '';
            this.note = '';
            this.description = '';
            this.variant_list = [{
              name: "Normal",
              image: null,
              description: "This is normal size",
              price: 0.00,
              index: 0
            }]
            // this.modifierList = [];
            // let mod_temp = JSON.parse(JSON.stringify(this.default_modifier));
            // if(mod_temp) {

            //   for(let i = 0; i < mod_temp.length; i++) {
            //     if(mod_temp[i].details) {

            //       for(let j = 0; j < mod_temp[i].details.length; j++) {
            //         mod_temp[i].details[j].price = parseFloat(mod_temp[i].details[j].price);
            //       }
            //     }
            //     this.modifierList.push(new Modifier(mod_temp[i]));
            //   }
            // }
            // this.modifierList = this.getAddStartList(this.new_modifier, this.modifierList);
            this.modifierList = this.getDefaultModifierList();
            this.new_modifier = [];
            for(let i = 0; i < this.modifierList.length; i++) {
              // this.modifierList[i].index = i;
              this.modifierList[i].changeStatusFalse();
            }
          }
        }
        // this.modifierList = this.getAddStartList(this.new_modifier, this.modifierList);
        // this.new_modifier = [];
        this.item_key++;
      }
    },
    modifier_list: {
      immediate: true,
      deep: true,
      handler() {
        // this.modifierList = this.modifier_list;
        // if(this.type == 'detail' && this.config.item_info && this.config.item_info.modifier) {
          // for(let i = 0; i < this.config.item_info.modifier.length; i++) {
          //   this.isModifierSelected(this.config.item_info.modifier[i]);
          // }
          if(this.type == 'add') {
            this.modifierList = this.getModifierList();
          }
        // }
      }
    }
  },
  methods: {
    selectId(e) {
      this.selectedId = e.id
    },
    getAddStartList(new_list, mod_list) {
      let result = [];
      for(let i = 0; i < mod_list.length; i++) {
        if(!this.isModifierSelected(mod_list[i], new_list)) {
          result.push(mod_list[i])
        }
      }
      return result;
    },
    getDefaultModifierList() {
      let temp = this.$store.getters['modifier/modifierList'];
      let default_list = [];
      for(let i = 0; i < temp.length; i++) {
        let mod = this.getnewModifier(temp[i]);
        mod.index = i;
        default_list.push(mod);
      }
      return default_list;
    },
    getModifierList() {
      let temp = this.$store.getters['modifier/modifierList'];
      let default_list = [];
      for(let i = 0; i < temp.length; i++) {
        default_list.push(this.getnewModifier(temp[i]));
      }
      let mod_list = [];
      if(this.type == 'detail' && this.config.item_info && this.config.item_info.modifier) {
        // for(let i = 0; i < this.config.item_info.modifier.length; i++) {
        //   if(this.config.item_info.modifier[i].is_selected) {
        //     this.config.item_info.modifier[i].changeStatusTrue();
        //   } else {
        //     this.config.item_info.modifier[i].changeStatusFalse();
        //   }
        // }
        // console.log(this.config.item_info.modifier);
        for(let i = 0; i < this.config.item_info.modifier.length; i++) {
          // if(this.config.item_info.modifier[i].is_selected) {
            this.config.item_info.modifier[i].inCurrent = true;
            mod_list.push(this.getnewModifier(this.config.item_info.modifier[i]));
          // }
          // } else {
          //   if(this.new_modifier) {
          //     this.new_modifier.push(this.config.item_info.modifier[i]);
          //     console.log(',,,,,,,,,,,,,,,,,');
          //   }
          // }
        }
      }
      if(mod_list.length > 0) {
        if(default_list.length > 0) {
          for(let i = 0 ; i < default_list.length; i++) {
            if(!this.isModifierSelected(default_list[i], mod_list)) {
              mod_list.push(default_list[i]);
            }
          }
        }
      } else {
        mod_list = default_list;
      }

      if(this.new_modifier) {
        for(let i = 0; i < this.new_modifier.length; i++) {
          mod_list.push(this.new_modifier[i]);
        }
      }

      mod_list = this.initModifierIndex(mod_list);
      return mod_list;
    },
    isModifierSelected(modifier, arr) {
      for(let i = 0; i < arr.length; i++) {
        if(modifier.modifier_name == arr[i].modifier_name) {
          return true;
        }
      }
      return false;
    },
    initModifierIndex(arr) {
      let temp_arr = arr;
      for(let i = 0; i < temp_arr.length; i++) {
        temp_arr[i].index = i;
      }
      return temp_arr;
    },
    addModifier() {
      this.editItemModifierCofig.isActive = true;
      this.editItemModifierCofig.item_info = {};
      this.editItemModifierCofig.type = "add";
      this.editItemModifierCofig.modifierList = this.modifierList;
      this.edit_mod_key++;
    },
    editModifier(modifier) {
      // console.log(modifier);
      this.editItemModifierCofig.isActive = true;
      this.editItemModifierCofig.item_info = modifier;
      this.editItemModifierCofig.type = "edit";
      this.editItemModifierCofig.modifierList = this.modifierList;
      this.edit_mod_key++;
    },
    getnewModifier(mod) {
      let modifier = JSON.parse(JSON.stringify(mod));
      if(modifier.details) {
        for(let i = 0; i < modifier.details.length; i++) {
          modifier.details[i].price = parseFloat(modifier.details[i].price);
        }
      }
      let obj = {
        title: modifier.modifier_name,
        status: modifier.status,
        created_at: modifier.created_at,
        updated_at: modifier.updated_at,
        modifier: {
          modifier_name: modifier.modifier_name,
          type: modifier.type,
          required: modifier.required,
          details: modifier.details
        },
        // is_selected: modifier.is_selected
      }
      if(modifier.id) {
        obj.id = modifier.id;
      }
      let result = new Modifier(obj);
      if(modifier.inCurrent) {
        result.inCurrent = modifier.inCurrent;
      }

      result.is_selected = modifier.is_selected;

      return result;
    },
    saveModifier(modifier) {
      let hasExisted = false;
      if(modifier && this.modifierList) {
        for(let i = 0; i < this.modifierList.length; i++) {
          if(modifier.index == this.modifierList[i].index) {
            this.modifierList[i].modifier_name = modifier.name;
            this.modifierList[i].title = modifier.name;
            this.modifierList[i].type = modifier.type;
            this.modifierList[i].required = modifier.required;
            this.modifierList[i].details = modifier.details;
            hasExisted = true;
            break;
          }
        }

        if(!hasExisted) {
          let temp = {
            // id: this.modifierList.length > 0 ? this.getNextId(this.modifierList) : 0,
            // id: null,
            // index: this.modifierList.length > 0 ? this.modifierList[this.modifierList.length - 1].index + 1 : 0,
            title: modifier.name,
            status: 1,
            created_at: null,
            updated_at: null,
            modifier: {
              modifier_name: modifier.name,
              type: modifier.type,
              required: modifier.required,
              details: modifier.details
            }
          }
          let new_mod = new Modifier(temp);
          new_mod.index = this.modifierList.length > 0 ? this.modifierList[this.modifierList.length - 1].index + 1 : 0;
          // this.modifierList.push(new Modifier(temp));
          // console.log(new_mod);
          new_mod.is_selected = true;
          this.modifierList.push(new_mod);
          this.new_modifier.push(new_mod);
        }
      }
      this.editItemModifierCofig.isActive = false;
      if(this.type == 'detail' && hasExisted) {
        this.saveModifierAfterEdit();
      }
      this.item_key++;
    },
    changeStatusCheckbox(modifier) {
      for(let i = 0; i < this.modifierList.length; i++) {
        if(this.modifierList[i].index == modifier.index) {
          this.modifierList[i].changeStatusSelected();
        }
      }
    },
    closePopup() {
      this.$emit("close");
    },
    isNumber: function(evt) {
      evt = evt ? evt : window.event;
      var charCode = evt.which ? evt.which : evt.keyCode;
      // if ((charCode > 31 && (charCode < 48 || charCode > 57) && charCode !== 46) || (charCode == 46 && this.input_price.indexOf(".") != -1)) {
      if (charCode > 31 && (charCode < 48 || charCode > 57)) {
        evt.preventDefault();
      } else {
        return true;
      }
    },
    isPriceNumber: function(evt, price) {
      evt = evt ? evt : window.event;
      var charCode = evt.which ? evt.which : evt.keyCode;
      if (
        (charCode > 31 &&
          (charCode < 48 || charCode > 57) &&
          charCode !== 46) ||
        (charCode == 46 && price.indexOf(".") != -1)
      ) {
        // if (charCode > 31 && (charCode < 48 || charCode > 57)) {
        evt.preventDefault();
      } else {
        return true;
      }
    },
    addVariation() {
      this.variant_list.push({
        index:
          this.variant_list && this.variant_list.length > 0
            ? this.variant_list[this.variant_list.length - 1].index + 1
            : 0,
        name: "",
        image: "https://www.mbrsg.ae/MBRSG/media/Images/no-image-icon-6.png",
        description: "",
        price: 0.00
      });
    },
    removeVariation(variant) {
      for (let i = 0; i < this.variant_list.length; i++) {
        if (this.variant_list[i].index == variant.index) {
          this.variant_list = this.variant_list.slice(); //shallow copy
          this.variant_list.splice(i, 1);
          return;
        }
      }
    },
    getVariantListToSubmit(list) {
      let arr = [];
      for(let i = 0; i < list.length; i++) {
        if(list[i].name != '') {
          let temp = list[i];
          temp.price = parseFloat(temp.price).toFixed(2);
          arr.push(temp);
        }
      }
      if(arr.length == 0) {
        arr.push({
          name: "Normal",
          image: null,
          description: "This is normal size",
          price: 0.00
        });
      }
      // console.log(arr);
      return arr;
    },
    saveModifierAfterEdit() {
      let data = {
        id: this.config.item_info.id,
        name: this.config.item_info.name,
        description: this.config.item_info.description,
        // image: "http://link_to_image.com",
        category_id: this.config.item_info.category_id,
        note: this.config.item_info.note,
        // type: "Test",
        visibility: 1,
        prepare_duration: this.config.item_info.prepare_duration,
        image: this.config.item_info.image,
        item_variants: this.config.item_info.item_variants,
        modifier: this.getModfierAfterEditToSubmit(),
        page: this.currentPage,
        "per-page" : this.itemPerPage
      };
      // console.log(data);
      this.$store.dispatch("item/ORDER_ITEM_UPDATE", data).then(() => {
        // this.$store.dispatch("item/ORDER_ITEM_LIST");
        this.$emit('GoToFirstPage');
      });
    },
    createItem(isCreate) {
      let data = {
        name: this.name,
        description: this.description,
        // image: "http://link_to_image.com",
        category_id: this.cate.id ? this.cate.id : '999999',
        note: this.note,
        // type: "Test",
        visibility: 1,
        prepare_duration: this.duration,
        image: this.item_image.image_url,
        item_variants: this.getVariantListToSubmit(this.variant_list),
        modifier: this.getModifierListToSubmit(),
        page: this.currentPage,
        "per-page" : this.itemPerPage
      };
      if (isCreate == false) {
        data.id = this.config.item_info.id;
      }
      if(this.item_name != '') {
        if (isCreate == true) {
          this.$store.dispatch("item/ORDER_ITEM_CREATE", data).then(() => {
            this.$vs.notify({
              title: "Success",
              text: "Create item successfully!",
              color: "success",
              position: "top-right"
            });
            this.closePopup();
            this.$emit('GoToLastPage');
          });
        } else {
          this.$store.dispatch("item/ORDER_ITEM_UPDATE", data).then(() => {
            this.$vs.notify({
              title: "Success",
              text: "Update item successfully!",
              color: "success",
              position: "top-right"
            });
            this.closePopup();
            this.$emit('GoToFirstPage');
          });
        }
      }
      this.$validator.validateAll();
    },
    handleUploaded(image) {
      this.item_image = image;
    },
    getModfierAfterEditToSubmit() {
      let mod_arr = [];
      for(let i = 0; i < this.modifierList.length; i++) {
        if(this.modifierList[i].inCurrent) {
          mod_arr.push({
            modifier_name: this.modifierList[i].modifier_name,
            type: this.modifierList[i].type,
            required: this.modifierList[i].required,
            details: this.modifierList[i].details,
            is_selected: this.modifierList[i].is_selected,
            id: this.modifierList[i].id
          });
        }
      }
      return mod_arr;
    },
    getModifierListToSubmit() {
      let mod_arr = [];
      for(let i = 0; i < this.modifierList.length; i++) {
        // if(this.modifierList[i].is_selected) {
          if(this.modifierList[i].inCurrent) {
            mod_arr.push({
              modifier_name: this.modifierList[i].modifier_name,
              type: this.modifierList[i].type,
              required: this.modifierList[i].required,
              details: this.modifierList[i].details,
              is_selected: this.modifierList[i].is_selected,
              id: this.modifierList[i].id
            });
          } else {
            if(this.modifierList[i].is_selected) {
              let obj = {
                modifier_name: this.modifierList[i].modifier_name,
                type: this.modifierList[i].type,
                required: this.modifierList[i].required,
                details: this.modifierList[i].details,
                is_selected: this.modifierList[i].is_selected,
              }
              if(this.modifierList[i].id != undefined && this.modifierList[i].id != null) {
                obj.id = this.modifierList[i].id;
              }
              mod_arr.push(obj);
            }
          }
        // }
      }
      for(let i = 0; i < this.new_modifier.length; i++) {
        if(!this.new_modifier[i].is_selected) {
          let obj = {
            modifier_name: this.new_modifier[i].modifier_name,
            type: this.new_modifier[i].type,
            required: this.new_modifier[i].required,
            details: this.new_modifier[i].details,
            is_selected: this.new_modifier[i].is_selected,
          }
          if(this.new_modifier[i].id != undefined && this.new_modifier[i].id != null) {
            obj.id = this.new_modifier[i].id;
          }
          mod_arr.push(obj);
        }
      }
      return mod_arr;
    }
  },
  computed: {
    item_name: {
      get() {
        return this.name;
      },
      set(value) {
        this.name = value;
      }
    },
    item_description: {
      get() {
        return this.description;
      },
      set(value) {
        this.description = value;
      }
    },
    item_note: {
      get() {
        return this.note;
      },
      set(value) {
        this.note = value;
      }
    },
    item_duration: {
      get() {
        return this.duration;
      },
      set(value) {
        this.duration = value;
      }
    },
    cate_id: {
      get() {
        return this.id;
      },
      set(value) {
        this.id = value;
      }
    },
    optionsCate() {
      return this.$store.state.category.categoryList;
    },
    modifier_list() {
      return this.$store.getters['modifier/modifierList'];
    }
  },
  created() {
    // this.$store.dispatch('modifier/GET_MODIFIER_LIST').then((response) => {
    //   this.default_modifier = response.items;
    // });
    this.$store.dispatch('modifier/GET_MODIFIER_LIST');
    this.$store.dispatch("category/LIST_CATEGORY")
  }
};
</script>